import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';


/**
 * Standard Info Popover for Outdoor Access - wrapper around the ngx-bootrap popover
 *  This popover is configured to close when clicked outside.
 * Example: <oapopover [title]="'Full Comment'" [content]="contact.comments"></oapopover>
 *
 */
@Component({
    // tslint:disable-next-line: component-selector
    selector: "oapopover",
    templateUrl: "./oapopover.component.html",
    styleUrls: ["./oapopover.component.css"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgbPopoverModule]
})
export class OAPopoverComponent implements OnInit {
  private readonly _componentName = 'OAPopoverComponent';

  private _content: string;
  private _title: string;
  private _enabled: boolean = true;

  constructor() {}

  ngOnInit() {}

  /**
   * Gets the enabled property value.  This is used to control visibility for the entire control
   */
  public get enabled(): boolean {
    // return false if there is no content:
    if (!this._content) {
      // console.log(`${this._componentName}.enabled returns false. No content.` );
      return false;
    }

    // console.log(`${this._componentName}.enabled returns ${this._enabled}.` );

    return this._enabled;
  }

  /**
   * Sets the enabled property value
   */
  @Input()
  public set enabled(v: boolean) {
    this._enabled = v;
  }

  /**
   * Gets the content to display in the popover
   */
  public get content(): string {
    // console.log(`${this._componentName}.content returns ${this._content}.` );

    return this._content;
  }

  /**
   * Sets the content
   */
  @Input()
  public set content(v: string) {
    this._content = v;

    // console.log(`${this._componentName}.content set to:`, v);
  }

  /**
   * Gets the popover title
   */
  public get title(): string {
    return this._title;
  }

  /**
   * Sets the popover title
   */
  @Input()
  public set title(v: string) {
    this._title = v;

    // console.log(`${this._componentName}.title set to:`, v);
  }
}
